import React from 'react';
import { Shield } from 'lucide-react';

/**
 * SecurityBadge Component
 * 
 * Displays a visual indicator that the login is protected with enterprise security.
 * Used to build user trust and confidence in the authentication process.
 * 
 * @example
 * <SecurityBadge />
 */
const SecurityBadge: React.FC = () => {
  return (
    <div 
      className="flex items-center justify-center gap-2 text-sm text-haat-gray-light mt-6"
      role="status"
      aria-label="Security status"
    >
      <Shield 
        className="w-4 h-4 text-green-500" 
        aria-hidden="true"
      />
      <span>Protected with enterprise-grade security</span>
    </div>
  );
};

export default SecurityBadge;

